var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgHidden16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.716 13.1302L13.2929 14.7071L14.7071 13.2929L2.70711 1.29289L1.29289 2.70711L2.57979 3.994C1.44109 4.96149 0.560667 6.22728 0.0560797 7.66982C-0.0186932 7.88359 -0.0186932 8.1164 0.0560797 8.33017C1.20913 11.6266 4.32474 14 8 14C9.33489 14 10.596 13.6869 11.716 13.1302ZM10.1958 11.61L9.29342 10.7076C8.90178 10.8951 8.46315 11 8 11C6.34315 11 5 9.65686 5 8C5 7.53686 5.10495 7.09822 5.29237 6.70659L3.99999 5.4142C3.15941 6.09207 2.49003 6.97941 2.06957 8C3.03961 10.3546 5.33469 12 8 12C8.77057 12 9.5102 11.8625 10.1958 11.61Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29541 2.17409C6.84571 2.05997 7.41578 2 8 2C11.6753 2 14.7909 4.37343 15.9439 7.66983C16.0187 7.88359 16.0187 8.11641 15.9439 8.33018C15.6553 9.15542 15.2436 9.92282 14.7309 10.6096L13.2976 9.17626C13.5464 8.80975 13.7591 8.41594 13.9304 8C12.9753 5.68152 10.7355 4.05068 8.12248 4.00116L6.29541 2.17409Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHidden16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;